import React, { useContext, useState } from 'react';
import { Box, Drawer, Typography, Avatar, Button, Divider, List, ListItem, ListItemButton, ListItemText, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useDispatch, useSelector } from 'react-redux';
import { ThemeContext } from '../../context/ThemeContext'
import { getCookies, removeCookies } from '../../services/Cookies';
import { addJournalLog } from '../../components/tab/tabview/journal/addJournalLog';
import { logout, setLoggedIn } from '../../store/Slices/userSlice';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';

const SideDrawer = ({ open, onClose }) => {
    const { accountId } = useSelector(state => state.accountSummary)
    const { userDetail } = useSelector((state) => state.user);
    const client = userDetail || {};
    const { darkMode } = useContext(ThemeContext)
    const [logoutConfirmOpen, setLogoutConfirmOpen] = useState(false);
    const dispatch = useDispatch()
    const navigate = useNavigate();

    const menuItems = [
        { label: 'Reports', path: '/reports' },
        { label: 'Journal', path: '/journal' },
        // { label: 'Mails', path: '/mails' },
        { label: 'News', path: '/news' },
        { label: 'Alerts', path: '/alerts' },
        { label: 'Settings', path: '/settings' },
        { label: 'About Us', path: '/about' },
        { label: 'Logout', action: 'logout' },
    ];
    const logo = '/logo192.png'
    const accountID = localStorage.getItem('accountID')
    const username = getCookies('username')
    const id = localStorage.getItem('clientId')
    const handleLogout = async () => {
        addJournalLog('logout', `Account ${username}: ${accountID} is logged out`);

        setTimeout(() => {
            removeCookies("username", { path: "/" });
            removeCookies("token", { path: "/" });
            removeCookies("clientId", { path: "/" });
            removeCookies('gmtOffset', { path: '/' });

            localStorage.removeItem(`visibleColumns_${id}`)
            localStorage.setItem("accountID", "");

            dispatch(setLoggedIn(false));
            dispatch(logout());

            window.location.href = "/";
        }, 200);
    };
    return (
        <>
            <Drawer anchor="left" open={open} onClose={onClose} PaperProps={{ sx: { width: 270 }, }}>
                <Box sx={{ p: 2, pt: 4, pb: 0 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'start', mb: 1, width: "44px" }}>
                        <Avatar sx={{ backgroundColor: '#000' }}><img alt='equitas' src={logo} style={{ width: 24, height: 24, }} /></Avatar>
                    </Box>
                    <Typography align="left" variant="subtitle1" fontWeight={600}>{`${client.userName || client.username || "Guest"}`}</Typography>
                    <Typography align="center" variant="caption" color="text.secondary">Account ID : {accountId}</Typography>

                    <Box sx={{ mt: 2 }}>
                        <Button onClick={() => navigate('/user')} fullWidth size="small" sx={{ justifyContent: 'space-between', textTransform: 'none', fontWeight: 500, px: 1.5, fontSize: 14, color: darkMode ? "white" : 'black' }} endIcon={<ChevronRightIcon />}>Manage Account</Button>
                    </Box>
                </Box>

                <Divider />
                <List>
                    {menuItems.map(({ label, path, action }) => (
                        <ListItem disablePadding key={label}>
                            <ListItemButton sx={{ px: 2, py: 0.5 }} onClick={() => {
                                if (action === 'logout') {
                                    setLogoutConfirmOpen(true);
                                } else {
                                    navigate(path);
                                    onClose();
                                }
                            }}>
                                <ListItemText primary={label} primaryTypographyProps={{ fontSize: 14, fontWeight: 500 }} />
                                <ChevronRightIcon fontSize="small" />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>

            </Drawer>
            <Dialog open={logoutConfirmOpen} onClose={() => setLogoutConfirmOpen(false)} PaperProps={{ sx: { borderRadius: 3, p: 0, minWidth: 320 } }}>
                <DialogTitle sx={{ fontSize: 16, fontWeight: 600, pb: 0 }}>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <span>Confirmation Message</span>
                        <IconButton aria-label="close" onClick={() => setLogoutConfirmOpen(false)} size="small" sx={{ ml: 2 }}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent sx={{ pb: 2 }}>
                    <Typography fontSize={14}>Are you sure you want to logout?</Typography>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button onClick={() => setLogoutConfirmOpen(false)} variant="outlined" fullWidth>Cancel</Button>
                    <Button onClick={() => { setLogoutConfirmOpen(false); handleLogout(); }} variant="contained" fullWidth color="primary">Log Out</Button>
                </DialogActions>
            </Dialog>

        </>
    );
};

export default SideDrawer;
